import { render, staticRenderFns } from "./CalculateProtonsNeutronsElectronsAmericium.vue?vue&type=template&id=969c8a70&"
import script from "./CalculateProtonsNeutronsElectronsAmericium.vue?vue&type=script&lang=js&"
export * from "./CalculateProtonsNeutronsElectronsAmericium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VSimpleTable,VTextField})
